module.exports = __webpack_public_path__ + "img/about1.e2d422e0.png";